import { CollectionStats } from "../../stats/CollectionStats"

type WazKBDashboardProps = {

}

export const WazKBDashboard = ({} : WazKBDashboardProps) => {

    return (
        <CollectionStats />
    )
}